import css from './styles.module.css'

export const TermsAndConditions = () => {
  return (
    <div className={css.terms_container}>
      By proceeding, you agree to the{' '}
      <a
        href="https://octopus.do/sitemap/terms"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms and Conditions
      </a>{' '}
      &amp;{' '}
      <a
        href="https://octopus.do/sitemap/privacy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy
      </a>{' '}
      and{' '}
      <a
        href="https://octopus.do/sitemap/cookies"
        target="_blank"
        rel="noopener noreferrer"
      >
        Cookies Policy.
      </a>
    </div>
  )
}
